// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qwc-route-page {
    min-height: 100vh;
    background: #f4f6f8;
    color: #17202a;
    font-family: Arial, sans-serif;
}

.qwc-route-nav {
    display: flex;
    align-items: center;
    gap: 8px;
    min-height: 56px;
    padding: 0 24px;
    background: #26313d;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.qwc-route-nav a {
    color: #ffffff;
    font-size: 14px;
    line-height: 1;
    padding: 10px 12px;
    text-decoration: none;
}

.qwc-route-nav a:hover,
.qwc-route-nav a:focus {
    background: rgba(255, 255, 255, 0.14);
    outline: none;
}

.qwc-route-content {
    max-width: 880px;
    padding: 56px 32px;
}

.qwc-route-content h1 {
    margin: 0 0 16px;
    font-size: 32px;
    font-weight: 600;
    letter-spacing: 0;
}

.qwc-route-content h2 {
    margin: 0 0 10px;
    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
}

.qwc-route-content p {
    max-width: 640px;
    margin: 0;
    color: #40505f;
    font-size: 17px;
    line-height: 1.55;
}

.qwc-route-kicker {
    margin-bottom: 8px;
    color: #647382;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: uppercase;
}

.qwc-route-panel {
    max-width: 680px;
    margin-top: 28px;
    padding: 20px;
    border: 1px solid #d7dde4;
    background: #ffffff;
}

.qwc-route-panel p,
.qwc-route-panel li {
    color: #40505f;
    font-size: 15px;
    line-height: 1.5;
}

.qwc-route-panel ul {
    margin: 0;
    padding-left: 18px;
}

.qwc-route-form {
    display: grid;
    gap: 14px;
    max-width: 420px;
    margin-top: 28px;
}

.qwc-route-form-wide {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-width: 720px;
}

.qwc-route-form label {
    display: grid;
    gap: 6px;
    color: #27333f;
    font-size: 14px;
    font-weight: 600;
}

.qwc-route-form input,
.qwc-route-form textarea {
    min-height: 40px;
    border: 1px solid #c9d1da;
    background: #ffffff !important;
    color: #17202a;
    font-family: Arial, sans-serif;
    font-size: 15px;
    padding: 0 10px;
}

.qwc-route-form input:invalid,
.qwc-route-form textarea:invalid {
    box-shadow: none;
}

.qwc-route-form textarea {
    min-height: 92px;
    padding: 10px;
    resize: vertical;
}

.qwc-route-form input:focus,
.qwc-route-form textarea:focus {
    border-color: #4f6f8f;
    outline: 2px solid rgba(79, 111, 143, 0.2);
}

.qwc-route-form-full {
    grid-column: 1 / -1;
}

.qwc-route-form button {
    min-height: 42px;
    border: 0;
    background: #2f5d7c;
    color: #ffffff;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    padding: 0 16px;
}

.qwc-route-form button:hover,
.qwc-route-form button:focus {
    background: #254b65;
    outline: none;
}

.qwc-route-form button:disabled {
    background: #8ea5b8;
    cursor: default;
}

.qwc-route-message {
    grid-column: 1 / -1;
    border: 1px solid;
    font-size: 14px;
    line-height: 1.45;
    padding: 10px 12px;
}

.qwc-route-message-success {
    border-color: #8ebf9c;
    background: #eef8f1;
    color: #1f5b2c;
}

.qwc-route-message-error {
    border-color: #d49a9a;
    background: #fff1f1;
    color: #8a1f1f;
}

@media (max-width: 640px) {
    .qwc-route-nav {
        flex-wrap: wrap;
        gap: 2px;
        padding: 8px 12px;
    }

    .qwc-route-nav a {
        font-size: 13px;
        padding: 9px 8px;
    }

    .qwc-route-content {
        padding: 36px 20px;
    }

    .qwc-route-content h1 {
        font-size: 26px;
    }

    .qwc-route-panel {
        padding: 16px;
    }

    .qwc-route-form-wide {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./js/routes.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;;IAEI,qCAAqC;IACrC,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;QACf,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".qwc-route-page {\n    min-height: 100vh;\n    background: #f4f6f8;\n    color: #17202a;\n    font-family: Arial, sans-serif;\n}\n\n.qwc-route-nav {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 56px;\n    padding: 0 24px;\n    background: #26313d;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);\n}\n\n.qwc-route-nav a {\n    color: #ffffff;\n    font-size: 14px;\n    line-height: 1;\n    padding: 10px 12px;\n    text-decoration: none;\n}\n\n.qwc-route-nav a:hover,\n.qwc-route-nav a:focus {\n    background: rgba(255, 255, 255, 0.14);\n    outline: none;\n}\n\n.qwc-route-content {\n    max-width: 880px;\n    padding: 56px 32px;\n}\n\n.qwc-route-content h1 {\n    margin: 0 0 16px;\n    font-size: 32px;\n    font-weight: 600;\n    letter-spacing: 0;\n}\n\n.qwc-route-content h2 {\n    margin: 0 0 10px;\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 0;\n}\n\n.qwc-route-content p {\n    max-width: 640px;\n    margin: 0;\n    color: #40505f;\n    font-size: 17px;\n    line-height: 1.55;\n}\n\n.qwc-route-kicker {\n    margin-bottom: 8px;\n    color: #647382;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0;\n    text-transform: uppercase;\n}\n\n.qwc-route-panel {\n    max-width: 680px;\n    margin-top: 28px;\n    padding: 20px;\n    border: 1px solid #d7dde4;\n    background: #ffffff;\n}\n\n.qwc-route-panel p,\n.qwc-route-panel li {\n    color: #40505f;\n    font-size: 15px;\n    line-height: 1.5;\n}\n\n.qwc-route-panel ul {\n    margin: 0;\n    padding-left: 18px;\n}\n\n.qwc-route-form {\n    display: grid;\n    gap: 14px;\n    max-width: 420px;\n    margin-top: 28px;\n}\n\n.qwc-route-form-wide {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    max-width: 720px;\n}\n\n.qwc-route-form label {\n    display: grid;\n    gap: 6px;\n    color: #27333f;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.qwc-route-form input,\n.qwc-route-form textarea {\n    min-height: 40px;\n    border: 1px solid #c9d1da;\n    background: #ffffff !important;\n    color: #17202a;\n    font-family: Arial, sans-serif;\n    font-size: 15px;\n    padding: 0 10px;\n}\n\n.qwc-route-form input:invalid,\n.qwc-route-form textarea:invalid {\n    box-shadow: none;\n}\n\n.qwc-route-form textarea {\n    min-height: 92px;\n    padding: 10px;\n    resize: vertical;\n}\n\n.qwc-route-form input:focus,\n.qwc-route-form textarea:focus {\n    border-color: #4f6f8f;\n    outline: 2px solid rgba(79, 111, 143, 0.2);\n}\n\n.qwc-route-form-full {\n    grid-column: 1 / -1;\n}\n\n.qwc-route-form button {\n    min-height: 42px;\n    border: 0;\n    background: #2f5d7c;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: 600;\n    padding: 0 16px;\n}\n\n.qwc-route-form button:hover,\n.qwc-route-form button:focus {\n    background: #254b65;\n    outline: none;\n}\n\n.qwc-route-form button:disabled {\n    background: #8ea5b8;\n    cursor: default;\n}\n\n.qwc-route-message {\n    grid-column: 1 / -1;\n    border: 1px solid;\n    font-size: 14px;\n    line-height: 1.45;\n    padding: 10px 12px;\n}\n\n.qwc-route-message-success {\n    border-color: #8ebf9c;\n    background: #eef8f1;\n    color: #1f5b2c;\n}\n\n.qwc-route-message-error {\n    border-color: #d49a9a;\n    background: #fff1f1;\n    color: #8a1f1f;\n}\n\n@media (max-width: 640px) {\n    .qwc-route-nav {\n        flex-wrap: wrap;\n        gap: 2px;\n        padding: 8px 12px;\n    }\n\n    .qwc-route-nav a {\n        font-size: 13px;\n        padding: 9px 8px;\n    }\n\n    .qwc-route-content {\n        padding: 36px 20px;\n    }\n\n    .qwc-route-content h1 {\n        font-size: 26px;\n    }\n\n    .qwc-route-panel {\n        padding: 16px;\n    }\n\n    .qwc-route-form-wide {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
